export default (props, vars) => props?.['mode'] === 'proposal';
